@if (!embedded) {
  <div class="sail-header">
    <img src="assets/ai-sail.png" />
    <span class="flex-filler" translate>SAIL</span>
    <mat-icon class="close-button" (click)="onClose()">close</mat-icon>
  </div>
}
<div #sailBody class="sail-body" [class.sail-body-embedded]="embedded">
  @if (!embedded) {
    <div class="app-bold-font" translate>Meet SAIL - Your Smart AI Assistant</div>
    <p translate>
    Hi there! I'm SAIL, Trendemon's AI support agent, here to help you chart a smoother path to website success.</p>
    <p translate>Need help with setup, journey optimization, or "how-to" guidance? Just ask! I can answer questions,
    guide you through best practices, and even automate routine tasks.</p>
    <p class="app-bold-font" translate>Ask me anything — I’m here to keep you on course.</p>
  }

  <div class="chat-container" [class.chat-container-bottom-space]="isSentFirstRequest()">
    @for (msg of chatMessages(); track $index) {
      @if(msg.type === 'user') {
        <div #userMessage class="user-message"> {{ msg.userMessage }} </div>
      } @else if (msg.type === 'assistant') {
        <div class="assistant-message">
          @for (block of msg.aiResponse.blocks; track $index) {
            @if (block.type === 'markdown') {
              <app-md-viewer [content]="block.markdown" [openLinksInNewTab]="true"></app-md-viewer>
            }
          }
        </div>
      }
    }
    @if (isSendingPrompt()) {
      <app-loader></app-loader>
    }

    @if (isContextLengthExceeded()) {
      <div class="too-long-conversation">Your conversation is too long.</div>
      <div class="buttons-container">
        <button class="app-small-text-btn" (click)="onRestartConversation()">Restart Conversation</button>
      </div>
    } @else if (assistantError(); as error) {
      <div class="assistant-error">
        @if (error.code === 'server_is_overloaded') {
          {{ error.message }}
        } @else {
          Error occured.
        }
      </div>
    }
  </div>

  @if (!isContextLengthExceeded()) {
    <div class="sail-input" [class.sail-input-float]="isSentFirstRequest()" [class.sail-input-embedded]="embedded">
      <textarea autoResize placeholder="Type your questions here" rows="1" [(ngModel)]="promptInput"
        [disabled]="isSendingPrompt()" (keydown.enter)="onEnter($event)">
      </textarea>
      <div class="send-message-button" (click)="onSendMessage()"><mat-icon>north</mat-icon></div>
    </div>
  }

  @if (!embedded) {
    <p class="support-contact" translate>
      <mat-icon svgIcon="support"></mat-icon>
      Need to contact support? <a href="#" class="support-link" (click)="onOpenTicket(); $event.preventDefault()">Open
          a ticket</a>
    </p>
  }
</div>
